import { PanelTrimType } from '../enums';

/**
 * Maps a panel connection angle to the corner trim profile it requires
 * @param angle connection angle in degrees, or null when there is no connection
 * @returns PanelTrimType, or null when the angle carries no corner trim
 */
export const getTrimTypeForConnectionAngle = (angle: number | null): PanelTrimType | null => {
	switch (angle) {
		case 90:
			return PanelTrimType.ninety;
		case 45:
			return PanelTrimType.fortyfive;
		default:
			return null;
	}
};
